import { pageInfo, addData, updateData, deleteData, downtemplate, uploadMaterielLq } from './../api';

const materielLq = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    addDataObj: null,
    updateDataObj: null,
    deleteDataObj: null,
    downtemplateObj: null,
    uploadMaterielLqObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, true] }));
    },
    ADD_DATA(state, data) {
      state.addDataObj = data;
    },
    UPDATE_DATA(state, data) {
      state.updateDataObj = data;
    },
    DELETE_DATA(state, data) {
      state.deleteDataObj = data;
    },
    DOWN_TEMPLATE_DATA(state, data) {
      state.downtemplateObj = data;
    },
    UPLOAD_MATERIEL_LQ_DATA(state, data) {
      state.uploadMaterielLqObj = data;
    },
  },
  actions: {
    async pageInfo({ commit }, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async addData({ commit }, obj) {
      let resp = await addData(obj);
      commit('ADD_DATA', resp);
    },
    async updateData({ commit }, obj) {
      let resp = await updateData(obj);
      commit('UPDATE_DATA', resp);
    },
    async deleteData({ commit }, obj) {
      let resp = await deleteData(obj);
      commit('DELETE_DATA', resp);
    },
    async downtemplate({ commit }, obj) {
      let resp = await downtemplate(obj);
      commit('DOWN_TEMPLATE_DATA', resp);
    },
    async uploadMaterielLq({ commit }, obj) {
      let resp = await uploadMaterielLq(obj);
      commit('UPLOAD_MATERIEL_LQ_DATA', resp);
    },
  }
};

export default materielLq;



// WEBPACK FOOTER //
// ./src/page/md/materielLq/store/materielLq.store.js